import { isValidImages, getFrontImage } from '@grandvisionhq/utils';

const getLineItemImageUrl = (variant, staticsUrl, isBynderImagesEnabled)=>{
    var ref, ref1;
    if (isBynderImagesEnabled) {
        var ref2, ref3;
        const images = isValidImages((ref2 = variant.media) === null || ref2 === void 0 ? void 0 : ref2.images) ? (ref3 = variant.media) === null || ref3 === void 0 ? void 0 : ref3.images : undefined;
        const imageUrl = getFrontImage(images).url;
        return `${imageUrl}?w=275&fm=jpeg&auto=format`;
    }
    if (variant === null || variant === void 0 ? void 0 : (ref = variant.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) {
        var ref4;
        return `${staticsUrl}${variant === null || variant === void 0 ? void 0 : (ref4 = variant.images) === null || ref4 === void 0 ? void 0 : ref4[0].url}?w=275&fm=jpeg&auto=format`;
    }
    return `${staticsUrl}`;
};

export { getLineItemImageUrl };
//# sourceMappingURL=get-line-item-image-url.js.map
